import { Injectable } from '@angular/core';
import { MetricsBaseService } from '@core/services/metrics/metrics-base.service';
import { map, Observable } from 'rxjs';
import { HttpContext, HttpHeaders } from '@angular/common/http';
import { API_CONTEXT_TOKEN, ProductName } from '@core/constants';
import { EvaluateData } from '@shared/models/service-line-routing.model';
import { AuthorizationCaseMetric } from '@products/dmepos/models/authorization-case-metric.model';

@Injectable({
  providedIn: 'root',
})
export class CaseMetricsService extends MetricsBaseService {
  uniqueKey = 'authorizationCaseMetricId';

  query(query: string): Observable<any> {
    const lobId = this.platformService.currentLineOfBusiness$.value?.lineOfBusinessId;
    const context = new HttpContext();
    context.set(API_CONTEXT_TOKEN, 'metrics');

    return this.http.post<any>(`${this.API_URL}/dmepos/lob/${lobId}/authorizationCaseMetrics/$query`, `"${query}"`, {
      headers: new HttpHeaders({ 'content-type': 'application/json' }),
      context,
    });
  }

  getEvaluateQueue(metric: AuthorizationCaseMetric): Observable<EvaluateData> {
    const lobId = this.platformService.currentLineOfBusiness$.value?.lineOfBusinessId;

    return this.http.get<EvaluateData>(
      `${this.API_URL}/dmepos/lob/${lobId}/authorizationCaseMetrics/${metric.authorizationCaseMetricId}/requirements`
    ).pipe(
      map((data) => {
        if (this.productName.value === ProductName.DMEPOS_MA && data) {
          delete data.resourceRequirements?.['MCO'];
          delete data.ruleRequirements?.['MCOs'];
        }

        return data;
      }),
    );
  }
}
